module.exports = __webpack_public_path__ + "img/mobilesurfer_completed.87c60782.svg";